(ns dre.components.tabs
  (:require
   [dre.utils.bem :as bem]
   [reagent.core :as reagent]))

(def component-name :tabs)

;; TODO: rewrite active tab selection logic
;; we don't need all of default-active-id active-id and overwrite-active-id params
(defn tabs
  [{:keys [default-active-id items]}]
  (let [first-id (-> items first :id)
        active-id (reagent/atom (or default-active-id first-id))]
    (fn [{:keys [items on-click overwrite-active-id]}]
      [:div
       {:class component-name}
       [:ul
        {:class (bem/be component-name :items)}
        (doall
         (map
          (fn [{:keys [id label] :as item}]
            (let [active? (= id (or overwrite-active-id @active-id))]
              ^{:key id}
              [:div
               {:class (bem/be component-name :item-group)}
               [:li
                {:class (bem/bem component-name :item (when active? :active))
                 :on-click #(do
                              (when-not overwrite-active-id
                                (reset! active-id id))
                              (when on-click
                                (on-click item)))}
                label]
               [:div
                {:class (bem/bem component-name :indicator (when active? :active))}]]))
          items))]
       [:div
        {:class (bem/be component-name :content)}
        [(or (:content (first (filter #(= (or overwrite-active-id @active-id) (:id %)) items)))
             :div)]]])))
